export const sortOptions = [
  {
    name: "Name : A to Z",
    value: "name_asc",
  },
  {
    name: "Name : Z to A",
    value: "name_desc",
  },
  {
    name: "Date Created : First to Last",
    value: "date_asc",
  },
  {
    name: "Date Created : Last to First",
    value: "date_desc",
  },
  // {
  //   name: "Last Viewed : First to Last",
  //   value: "last_viewed_asc",
  // },
  // {
  //   name: "Last Viewed : Last to First",
  //   value: "last_viewed_desc",
  // },
];

export const fileActionOptions = [
  {
    name: "Move",
    value: "move",
  },
  {
    name: "Add to starred items",
    value: "star",
  },
  {
    name: "Rename",
    value: "rename",
  },
  {
    name: "Delete",
    value: "delete",
  },
];

export const starredFileActionOptions = [
  {
    name: "Move",
    value: "move",
  },
  {
    name: "Remove from starred items",
    value: "unstar",
  },
  {
    name: "Delete",
    value: "delete",
  },
];
